import { useEffect as e } from "react";
//#region src/utils/useCloseOnOutsideClick.ts
function t(t, n, r) {
	e(() => {
		if (!t) return;
		function e(e) {
			r.current?.contains(e.target) || n(!1);
		}
		function i(e) {
			e.key === "Escape" && n(!1);
		}
		return document.addEventListener("mousedown", e), document.addEventListener("keydown", i), () => {
			document.removeEventListener("mousedown", e), document.removeEventListener("keydown", i);
		};
	}, [
		t,
		n,
		r
	]);
}
//#endregion
export { t as useCloseOnOutsideClick };
